import bannerDesktop from "assets/img/bannerDesktop.jpg";
import bannerMobile from "assets/img/bannerMobile.png";
import styled from "styled-components";
import {
  backgroundColorFailed,
  backgroundColorSuccess,
  backgroundColorWrongFormat,
  borderColorFailed,
  borderColorSuccess,
  borderColorWrongFormat,
  colorFailed,
  colorSuccess,
  colorWrongFormat,
  primaryColor,
  whiteColor,
} from "utils/variable";

const smallScreen = "767px";
const mediumScreen = "992px";
const largeScreen = "1200px";

export const StyledComponent = styled.div`
  .header {
    width: 100%;
    height: 950px;
    background-image: url(${bannerDesktop});
    background-size: cover;
    background-repeat: no-repeat;

    @media (max-width: ${smallScreen}) {
      background-image: url(${bannerMobile});
      height: 650px;
      background-size: contain;
    }

    @media (min-width: ${smallScreen}) and (max-width: ${mediumScreen}) {
      height: 650px;
    }

    @media (min-width: ${largeScreen}) {
      background-size: cover;
      height: 1300px;
    }

    .header-main {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .header-logo {
      display: flex;
      align-items: center;

      @media (max-width: ${smallScreen}) {
        flex-direction: column;
      }
    }

    .header-logo-main {
      width: 100px;
      height: 50px;
      margin-top: 20px;

      @media (max-width: ${smallScreen}) {
        width: 60px;
        height: 30px;
        margin-top: 4px;
      }

      @media (min-width: ${smallScreen}) and (max-width: ${mediumScreen}) {
        width: 120px;
        height: 60px;
        margin-top: 16px;
      }

      @media (min-width: ${largeScreen}) {
        background-size: cover;
      }
    }

    .header-logo-desc {
      color: ${primaryColor};
      font-size: 24px;
      font-weight: 600;
      line-height: 46px;
      margin: 16px 0 0 10px;

      @media (max-width: ${smallScreen}) {
        display: none;
      }

      @media (min-width: ${smallScreen}) and (max-width: ${mediumScreen}) {
        display: none;
      }

      @media (min-width: ${largeScreen}) {
        background-size: cover;
      }
    }

    .header-title {
      width: 70%;
      color: ${primaryColor};
      line-height: 24px;
      text-align: center;
      padding: 28px 0;

      @media (max-width: ${smallScreen}) {
        display: none;
      }
    }

    .header-title-heading {
      font-weight: 600;
    }

    .header-search-mobile-title {
      color: ${primaryColor};
      line-height: 24px;
      text-align: center;

      @media (min-width: ${smallScreen}) and (max-width: ${mediumScreen}) {
        display: none;
      }

      @media (min-width: ${smallScreen}) {
        display: none;
      }
    }

    .header-title-mobile-heading {
      font-weight: 600;
    }

    .header-search {
      position: relative;
      width: 70%;
      padding: 20px;
      background-color: ${whiteColor};
      border-radius: 20px;
      box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
        0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);

      @media (max-width: ${smallScreen}) {
        position: absolute;
        width: 80%;
        padding: 16px;
        background-color: rgb(255, 255, 255);
        border-radius: 20px;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 9px 28px 8px,
          rgba(0, 0, 0, 0.08) 0px 6px 16px, rgba(0, 0, 0, 0.12) 0px 3px 6px -4px;
        top: 48%;
        bottom: unset;
        transform: translateY(-58%);
      }

      @media (min-width: ${largeScreen}) {
        bottom: 50px;
        margin-top: 50px;
      }
    }

    .header-search-title {
      font-weight: 600;
      color: ${primaryColor};
      line-height: 24px;
      text-align: center;

      @media (max-width: ${smallScreen}) {
        display: none;
      }
    }

    .header-search-form {
      display: flex;
      margin-top: 24px;

      @media (max-width: ${smallScreen}) {
        flex-direction: column;
      }
    }

    .header-search-form-item {
      width: 100%;

      @media (max-width: ${smallScreen}) {
        margin-bottom: 4px;
      }
    }

    .header-search-box-input {
      height: 48px;
      border-radius: 6px 0 0 6px !important;

      @media (max-width: ${smallScreen}) {
        margin-bottom: 10px;
        border-radius: 0 !important;
      }
    }

    .header-search-box-btn {
      height: 48px;
      text-transform: uppercase;
      border-radius: 0 6px 6px 0 !important;

      &:hover {
        height: 48px;
      }

      @media (max-width: ${smallScreen}) {
        border-radius: 0 !important;
      }
    }

    .header-search-result-checking {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }

    .header-search-result-checking-desc {
      padding-right: 6px;
    }

    .header-search-result-success {
      font-size: 14px;
      line-height: 18px;
      color: ${colorSuccess};
      background-color: ${backgroundColorSuccess};
      border: 1px solid ${borderColorSuccess};
      padding: 10px;
      border-radius: 2px;
    }

    .header-search-result-wrong-format {
      font-size: 14px;
      line-height: 18px;
      color: ${colorWrongFormat};
      background-color: ${backgroundColorWrongFormat};
      border: 1px solid ${borderColorWrongFormat};
      padding: 10px;
      border-radius: 2px;
    }

    .header-search-result-failed {
      font-size: 14px;
      line-height: 18px;
      color: ${colorFailed};
      background-color: ${backgroundColorFailed};
      border: 1px solid ${borderColorFailed};
      padding: 10px;
      border-radius: 2px;
    }

    .guide-get-link-facebook {
      position: absolute;
      bottom: -60px;
      left: 50%;
      transform: translateX(-50%);
      color: ${primaryColor};
      font-weight: 500;
      border: none;
      border-radius: 20px;
    }
  }
`;
